import gql from 'graphql-tag';

export const FRAGMENT_CUSTOM_FORMAT = gql`
  fragment CustomFormat on CustomFormat {
    id
    name
    instructions
    defaultForGenerationTools
    autoGenerated
  }
`;

export const FRAGMENT_CUSTOM_FORMAT_GROUP = gql`
  fragment CustomFormatGroup on CustomFormatGroup {
    id
    name
  }
`;
